export const MAIN_MENU = ['about', 'work', 'services', 'people']
export const SUB_MENU = ['home', 'contact', 'vacancies', 'updates']
export const SERVICES = [
  { label: 'Strategry & Insights', value: 'strategy', key: '15c6c418199f' },
  { label: 'Campaigns', value: 'campaigns', key: '57530d303383' },
  { label: 'Commerce', value: 'commerce', key: 'f1c1d9e0c8d4' },
  { label: 'Digital & Tech', value: 'digital', key: '21f22787f037' },
  { label: 'Design & Production', value: 'design', key: '3cd5d747e691' }
]
